import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

// 弹窗状态类型定义
export interface DialogState {
  // 新用户弹窗
  showAppNewUser: boolean
  // 可以扩展其他弹窗状态
  // showLoginDialog: boolean
  // showFirstChargePopUp: boolean
}

export const useDialogStore = defineStore('dialog', () => {
  // 弹窗状态
  const showAppNewUser = ref(false)

  // 计算属性
  const hasAnyDialogOpen = computed(() => {
    return showAppNewUser.value
  })

  // 打开新用户弹窗
  const openAppNewUser = () => {
    showAppNewUser.value = true
  }

  // 关闭新用户弹窗
  const closeAppNewUser = () => {
    showAppNewUser.value = false
  }

  // 切换新用户弹窗状态
  const toggleAppNewUser = () => {
    showAppNewUser.value = !showAppNewUser.value
  }

  // 关闭所有弹窗
  const closeAllDialogs = () => {
    showAppNewUser.value = false
    // 可以扩展关闭其他弹窗
  }

  return {
    // 状态
    showAppNewUser,

    // 计算属性
    hasAnyDialogOpen,

    // 方法
    openAppNewUser,
    closeAppNewUser,
    toggleAppNewUser,
    closeAllDialogs
  }
})

